module.exports = __webpack_public_path__ + "img/app-logos.5ec97c7c.png";